import { Injectable } from '@angular/core';
import { IDataTableService } from '../common/interfaces/IDataTableService.interface';
import { AttributeRow } from './attribute-row.model';
import { HttpClient } from '@angular/common/http';
import { DataTableFilter } from '../common/models/DataTableFilter.model';
import { Observable } from 'rxjs';
import { IPagedDataTable } from '../common/interfaces/IPagedDataTable.interface';
import { UrlPrefix } from "../common/constants/url-prefix.constants";

@Injectable()
export class AttributesDataTableService implements IDataTableService<AttributeRow> {

  public productId: number;

  constructor(private http: HttpClient) {
  }

  public getRows(filter: DataTableFilter): Observable<IPagedDataTable<AttributeRow>> {
    return this.http.get<IPagedDataTable<AttributeRow>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/products/${this.productId}/attributes/available?${filter.toQueryString()}`);
  }

}

